module.exports = __webpack_public_path__ + "static/media/How can you incorporate client_s account balance into your agreement.e5d3b3f8.png";